import { Component, Input } from '@angular/core';

@Component({
  selector: 'adminapp-summary-detail-template',
  templateUrl: './summary-detail-template.component.html',
  styleUrls: ['./summary-detail-template.component.scss']
})
export class SummaryDetailTemplateComponent {

  @Input() title: any;
  @Input() description: string;

  constructor() { }
}
